
import React, { useState } from "react";
import ShopifyModal from "../../../../../components/ShopifyModal";
import { reqGetPersonInventoryListDataRemove } from "../../../../../api";
const Index = ({removeData,setRemoveData,resetCallback}) => {
    const [saveLoading, setSaveLoading] = useState(false);
    const handleSave = async () => {
        setSaveLoading(true);
        let res = await reqGetPersonInventoryListDataRemove({inventory_id:removeData.id})
        if (res.code === '200') {
          setRemoveData((prevValue)=>({...prevValue,open:false}))
          resetCallback()
        }
      };
  return (
    <div className="upgrade_new_feature">
      <ShopifyModal id="remove-inventory-modal"
        open={removeData.open}
        onClose={() => 
          {
            setRemoveData((prevValue)=>({...prevValue,open:false}))
            setSaveLoading(false)
          }}
        heading={'Remove Inventory'}
        primaryAction={{
          content: "Apply",
          loading:saveLoading,
          onAction: () => {
            handleSave()
          },
        }}
        secondaryActions={[
          {
            content: "Cancel",
            onAction: () => {
              setRemoveData((prevValue)=>({...prevValue,open:false}))
              setSaveLoading(false)
            }
          },
        ]}
      >
        <p style={{fontSize:'14px'}}>{'Are you sure you want to remove this inventory?'}</p>
        </ShopifyModal>
    </div>
  );
};

export default Index;
